/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ number: NonNullable<unknown> }} Earth_Day_2025_Donate_Land_PlanInputs */

const en_earth_day_2025_donate_land_plan = /** @type {(inputs: Earth_Day_2025_Donate_Land_PlanInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Restores ~${i?.number} m² of green land`)
};

const ar_earth_day_2025_donate_land_plan = /** @type {(inputs: Earth_Day_2025_Donate_Land_PlanInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`يستعيد ~${i?.number} م² من الأراضي الخضراء`)
};

const de_earth_day_2025_donate_land_plan = /** @type {(inputs: Earth_Day_2025_Donate_Land_PlanInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Stellt ~${i?.number} m² Grünfläche wieder her`)
};

const es_earth_day_2025_donate_land_plan = /** @type {(inputs: Earth_Day_2025_Donate_Land_PlanInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Restaura ${i?.number} m² de zonas verdes`)
};

const fr_earth_day_2025_donate_land_plan = /** @type {(inputs: Earth_Day_2025_Donate_Land_PlanInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Revitalise près de ~${i?.number} m² d'espaces naturels`)
};

const it_earth_day_2025_donate_land_plan = /** @type {(inputs: Earth_Day_2025_Donate_Land_PlanInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ripristina ~${i?.number} m² di terreno verde`)
};

const ja_earth_day_2025_donate_land_plan = /** @type {(inputs: Earth_Day_2025_Donate_Land_PlanInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`約${i?.number}m²の緑地を復元`)
};

const ko_earth_day_2025_donate_land_plan = /** @type {(inputs: Earth_Day_2025_Donate_Land_PlanInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`최대 ${i?.number}m² 산림 복원`)
};

const pt_br_earth_day_2025_donate_land_plan = /** @type {(inputs: Earth_Day_2025_Donate_Land_PlanInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Restaura ~${i?.number} m² de área verde`)
};

const ru_earth_day_2025_donate_land_plan = /** @type {(inputs: Earth_Day_2025_Donate_Land_PlanInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Восстанавливает ~${i?.number} м² зелёной территории`)
};

const th_earth_day_2025_donate_land_plan = /** @type {(inputs: Earth_Day_2025_Donate_Land_PlanInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`ฟื้นฟูพื้นที่สีเขียว ~${i?.number} ตร.ม.`)
};

const tr_earth_day_2025_donate_land_plan = /** @type {(inputs: Earth_Day_2025_Donate_Land_PlanInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`~${i?.number} m² yeşil alanı restore eder`)
};

const zh_cn_earth_day_2025_donate_land_plan = /** @type {(inputs: Earth_Day_2025_Donate_Land_PlanInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`复育约 ${i?.number} 平方公尺绿地`)
};

const zh_tw_earth_day_2025_donate_land_plan = /** @type {(inputs: Earth_Day_2025_Donate_Land_PlanInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`復育約 ${i?.number} 平方公尺綠地`)
};

/**
* | output |
* | --- |
* | "Restores ~{number} m² of green land" |
*
* @param {Earth_Day_2025_Donate_Land_PlanInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const earth_day_2025_donate_land_plan = /** @type {((inputs: Earth_Day_2025_Donate_Land_PlanInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Earth_Day_2025_Donate_Land_PlanInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_earth_day_2025_donate_land_plan(inputs)
	if (locale === "ar") return ar_earth_day_2025_donate_land_plan(inputs)
	if (locale === "de") return de_earth_day_2025_donate_land_plan(inputs)
	if (locale === "es") return es_earth_day_2025_donate_land_plan(inputs)
	if (locale === "fr") return fr_earth_day_2025_donate_land_plan(inputs)
	if (locale === "it") return it_earth_day_2025_donate_land_plan(inputs)
	if (locale === "ja") return ja_earth_day_2025_donate_land_plan(inputs)
	if (locale === "ko") return ko_earth_day_2025_donate_land_plan(inputs)
	if (locale === "pt_br") return pt_br_earth_day_2025_donate_land_plan(inputs)
	if (locale === "ru") return ru_earth_day_2025_donate_land_plan(inputs)
	if (locale === "th") return th_earth_day_2025_donate_land_plan(inputs)
	if (locale === "tr") return tr_earth_day_2025_donate_land_plan(inputs)
	if (locale === "zh_cn") return zh_cn_earth_day_2025_donate_land_plan(inputs)
	return zh_tw_earth_day_2025_donate_land_plan(inputs)
});